import { useState } from 'react';

const MainProductGroupModel = () => {
  const initialState = {
    id: '',
    mainProductGroupName: '',
  };

  const [mainProductGroup, setMainProductGroup] = useState(initialState);

  return { mainProductGroup, setMainProductGroup, initialState };
};

export default MainProductGroupModel;
